// components/Parrainage/ParrainageSection.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const ParrainageSection = () => {
  const apiUrl = "https://api.monappliclub.com/api/parrainage";
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nom_parrain: "",
    prenom_parrain: "",
    club_parrain: "",
    email_parrain: "",
    telephone_parrain: "",
    club_parraine: "",
    nom_contact_parraine: "",
    prenom_contact_parraine: "",
    email_parraine: "",
    telephone_parraine: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.monappliclub.com/api/parrainage/addParrainage",
        formData
      );
      if (response.status === 201 || response.status === 200) {
        toast.success("Parrainage envoyé avec succès !");
        setFormData({
          nom_parrain: "",
          prenom_parrain: "",
          club_parrain: "",
          email_parrain: "",
          telephone_parrain: "",
          club_parraine: "",
          nom_contact_parraine: "",
          prenom_contact_parraine: "",
          email_parraine: "",
          telephone_parraine: "",
        });
        setShowForm(false);
      } else {
        throw new Error("Réponse non valide de l’API.");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du parrainage :", error);
      toast.error("Erreur lors de l'envoi du parrainage.");
    }
  };


  

  return (
    <section className="bg-gray-100 dark:bg-neutral-900 text-gray-800 dark:text-gray-200 py-12 px-4 mt-8 rounded-md shadow-md">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
          Parrainez un club et bénéficiez de réductions
        </h2>
        <p className="text-center text-lg mb-6">
          5% de réduction pour vous et le club parrainé. 10% si vous parrainez
          plusieurs clubs.
        </p>

        <div className="flex flex-col lg:flex-row gap-6 items-center">
          <div className="lg:w-1/2 text-left space-y-4">
            <ul className="list-disc pl-5 text-lg">
              <li>
                <strong>5%</strong> sur votre prochaine facture annuelle
              </li>
              <li>
                Le club parrainé gagne aussi <strong>5%</strong>
              </li>
              <li>
                <strong>10%</strong> si vous parrainez plusieurs clubs
              </li>
            </ul>
            <button
              onClick={() => setShowForm(!showForm)}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
            >
              Parrainez un Club
            </button>
          </div>

          <div className="lg:w-1/2">
            <img
              src="/images/parrainage_02.png"
              alt="Parrainage"
              className="rounded-lg shadow w-full"
            />
          </div>
        </div>

        {showForm && (
          <form
            onSubmit={handleSubmit}
            className="grid gap-6 mt-8 lg:grid-cols-2 bg-white dark:bg-gray-800 p-6 rounded shadow"
          >
            <div>
              <h3 className="font-bold text-blue-600 mb-2">Club Parrain</h3>
              <input
                name="club_parrain"
                value={formData.club_parrain}
                onChange={handleInputChange}
                required
                placeholder="Club Parrain"
                className="input w-full"
              />
              <input
                name="nom_parrain"
                value={formData.nom_parrain}
                onChange={handleInputChange}
                required
                placeholder="Nom"
                className="input w-full mt-2"
              />
              <input
                name="prenom_parrain"
                value={formData.prenom_parrain}
                onChange={handleInputChange}
                required
                placeholder="Prénom"
                className="input w-full mt-2"
              />
              <input
                name="email_parrain"
                type="email"
                value={formData.email_parrain}
                onChange={handleInputChange}
                required
                placeholder="Email"
                className="input w-full mt-2"
              />
              <input
                name="telephone_parrain"
                value={formData.telephone_parrain}
                onChange={handleInputChange}
                placeholder="Téléphone"
                className="input w-full mt-2"
              />
            </div>

            <div>
              <h3 className="font-bold text-blue-600 mb-2">Club Parrainé</h3>
              <input
                name="club_parraine"
                value={formData.club_parraine}
                onChange={handleInputChange}
                required
                placeholder="Club Parrainé"
                className="input w-full"
              />
              <input
                name="nom_contact_parraine"
                value={formData.nom_contact_parraine}
                onChange={handleInputChange}
                placeholder="Nom du contact"
                className="input w-full mt-2"
              />
              <input
                name="prenom_contact_parraine"
                value={formData.prenom_contact_parraine}
                onChange={handleInputChange}
                placeholder="Prénom du contact"
                className="input w-full mt-2"
              />
              <input
                name="email_parraine"
                type="email"
                value={formData.email_parraine}
                onChange={handleInputChange}
                placeholder="Email"
                className="input w-full mt-2"
              />
              <input
                name="telephone_parraine"
                value={formData.telephone_parraine}
                onChange={handleInputChange}
                placeholder="Téléphone"
                className="input w-full mt-2"
              />
            </div>

            <div className="col-span-2 text-center">
              <button
                type="submit"
                className="bg-blue-600 text-white px-8 py-3 rounded hover:bg-blue-700 transition"
              >
                Envoyer le Parrainage
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
};

export default ParrainageSection;
